var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 217 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.581 0L142.07 26.603V0.395078H147.618V40L119.129 12.6231V39.8284H113.581V0ZM187.666 0.395065H180.088L164.816 15.7157V0.395065H159.271V39.8284H164.816V22.9307L165.066 22.6813L180.413 39.8284H188.029L168.978 18.8828L187.666 0.395065ZM201.087 22.0207V0.395065H195.513L195.542 39.8284H201.087V34.6114C204.428 37.6069 209.714 39.8251 216.129 39.8251V34.8866C209.623 34.8866 201.087 31.2888 201.087 22.0207ZM84.0945 0.310886C73.0657 0.310886 64.0952 9.21633 64.0952 20.1619C64.0952 31.1075 73.0657 39.9158 84.0945 39.9158C95.1234 39.9158 104.094 31.0557 104.094 20.1619C104.094 9.26814 95.1234 0.310886 84.0945 0.310886ZM84.0945 34.6114C76.1597 34.6114 69.7054 28.1056 69.7054 20.1101C69.7054 12.1146 76.1597 5.61205 84.0945 5.61205C92.0293 5.61205 98.4837 12.1146 98.4837 20.1101C98.4837 28.1056 92.0293 34.6114 84.0945 34.6114ZM35.7813 28.125L49.3879 0.0906864L57.5792 39.8284H51.9073L47.1997 16.6321L35.791 39.8316L24.1485 17.0272L19.7104 39.8284H14.0385L15.1196 34.6114C10.7821 37.7817 5.14918 39.783 0 39.8219V34.8834C6.40563 34.8154 15.8014 30.3983 17.3923 23.6432L22.2557 0.155453L35.7813 28.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonki);
export default __webpack_public_path__ + "static/media/Monki.cbd29fc727b754e1d3cd244523cff7fb.svg";
export { ForwardRef as ReactComponent };